import { render, staticRenderFns } from "./NormalSearchNav531.vue?vue&type=template&id=f27ff02e&scoped=true"
import script from "./NormalSearchNav531.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav531.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27ff02e",
  null
  
)

export default component.exports